import React, { useState } from "react"

interface IndexProps {
  min: number
  max: number
  amount?: number
}

function choiceForAmount(amount) {
  if (amount === 25 || amount === 50 || amount === 100) {
    return amount.toString()
  } else if (amount) {
    return "other"
  } else {
    return null
  }
}

export default function Index({ min, max, ...props }: IndexProps) {
  const [amount, setAmount] = useState(props.amount)
  const [choice, setChoice] = useState(choiceForAmount(props.amount))

  function setChoiceAmount(amount) {
    setAmount(amount)
    setChoice(amount)
  }

  function enterOtherAmount() {
    setAmount(null)
    setChoice("other")
  }

  function updateAmount(value) {
    const scrubbedValue = value.replace(/\D/g, "")
    setAmount(scrubbedValue && scrubbedValue.length > 0 ? parseInt(scrubbedValue) : null)
    const otherAmount = document.getElementById("other-amount") as HTMLObjectElement | null
    if (otherAmount) {
      otherAmount.setCustomValidity("")
    }
  }

  function goToCheckout(e) {
    e.preventDefault()

    if (!amount) return

    if (amount >= min && amount <= max) {
      window.location.href = `/app/create_cart/gift_card/${amount}`
    } else {
      const otherAmount = document.getElementById("other-amount") as HTMLObjectElement
      otherAmount.setCustomValidity(`Gift card amount must be an amount between $${min} and $${max}`)
      otherAmount.reportValidity()
    }
  }

  return (
    <form id="gift-card-options">
      <ul>
        {["25", "50", "100"].map((amount) => {
          return (
            <li
              key={amount}
              className={choice === amount ? "choice active" : "choice"}
              onClick={() => setChoiceAmount(amount)}
            >
              ${amount}
            </li>
          )
        })}
        <li className={choice === "other" ? "choice active" : "choice"} onClick={enterOtherAmount}>
          {choice === "other" ? (
            <>
              $
              <input
                id="other-amount"
                type="text"
                value={amount ?? ""}
                onChange={(e) => updateAmount(e.target.value)}
                maxLength={3}
                autoFocus={true}
                inputMode="numeric"
              />
            </>
          ) : (
            "Other"
          )}
        </li>
      </ul>

      <p className="hint">
        Spark rounds vary in price by course, generally <span className="no-wrap">between $25-$50</span>
      </p>

      <div>
        <a onClick={goToCheckout} className={`action-button block ${amount ? "" : "disabled"}`}>
          Buy Now
        </a>
      </div>
    </form>
  )
}
